import React from "react";
import { connect } from "react-redux";
import { Container as BsContainer, Row, Col, Input, FormFeedback } from "reactstrap";
import { DropArea, DropAreaContainer } from "../../../components/UI/DropArea/DropArea";
import { Droppable, Draggable } from "react-beautiful-dnd";
import { renderElement } from "../../../helpers/renderElement";
import { formActions } from "../../../../store/actions/cms/form/form.action";
import { DragContainer } from "../../../components/UI/DragContainer/DragContainer";
import { elementConstants } from "../../../../constants/cms/form/element/element.constants";
import { templateActions } from "../../../../store/actions/cms/template/template.action";
import { sourceTypes } from "../../../../constants/cms/sourceType";
import { pageActions } from "../../../../store/actions/cms/page/page.action";
import { ElementOverlay } from "../../../components/element/Overlay/ElementOverlay";
import { deepClone } from "../../../../helpers/objectHelper";

class Container extends React.Component {
  state = {
    element: null,
    isHovering: false,
    containerChildren: null,
    containerChildrenChildren: null,
    isDropDisabled: false,
  };

  componentDidMount() {
    const { cms, dispatch, element } = this.props;
    if (this.props.updateValidator && typeof this.props.updateValidator === "function") {
      this.props.updateValidator(this.updateValidator);
    }
    this.calculateChildren();
  }
  validateEventGroup = () => {
    const element = deepClone(this.props.element);
    let isValid = true;
    const groupId = element.id;

    if (element.data.type === "EVENT_GROUP" && this.props.cms.enviroment === sourceTypes.FORM) {
      let min = element.data.extra.min;
      const groupEvents = this.props.form.formElements.filter((fe) => {
        return fe.type === elementConstants.EVENT && fe.data.groupId === groupId && fe.props.isSelected === true;
      });
      if (groupEvents.length < min) {
        isValid = false;
      }
      if (this.props.element.isValid !== isValid) {
        element.isValid = isValid;
        this.handleUpdate(element);
      }
    }
    return isValid;
  };
  updateValidator = () => {
    if (this.props.getValidator && typeof this.props.getValidator === "function") {
      this.props.getValidator(() => this.validateEventGroup());
    }
  };
  handleUpdate = (element) => {
    const { dispatch, cms } = this.props;
    dispatch(formActions.updateFormElement(element));
  };
  componentWillUnmount() {
    if (this.props.updateValidator && typeof this.props.updateValidator === "function") {
      this.props.updateValidator(this.updateValidator, true);
    }
  }
  isDropDisabled = (element) => {
    if (element.parentName !== undefined && this.props.cms.enviroment !== sourceTypes.TEMPLATE && this.state.isDropDisabled === false) {
      this.setState({ isDropDisabled: true });
    }
  };
  componentDidUpdate(prevProps, prevState) {
    if (this.props.form !== undefined && (!prevProps.form || !prevProps.form.formElements || this.props.form.formElements != prevProps.form.formElements)) {
      this.calculateChildren();
    }
    if (this.props.page !== undefined && (!prevProps.page || !prevProps.page.pageElements || this.props.page.pageElements != prevProps.page.pageElements)) {
      this.calculateChildren();
    }
    if (
      this.props.template !== undefined &&
      (!prevProps.template || !prevProps.template.template || this.props.template.template.content != prevProps.template.template.content) &&
      this.props.cms.enviroment === sourceTypes.TEMPLATE
    ) {
      this.calculateChildren();
    }
  }
  calculateChildren = () => {
    const { element } = this.props;
    const elements = this.getElements();
    let containerChildren = elements.filter((el, i) => {
      return el.type === elementConstants.CONTAINER && el.parentId && el.parentId === element.id;
    });
    let containerChildrenChildren = [];
    containerChildren.map((el, i) => {
      containerChildrenChildren.push({
        id: el.id,
        elements: this.getChildren2(el.id, elements),
      });
    });
    this.isDropDisabled(element);
    return { element, containerChildren, containerChildrenChildren };
  };
  getInheritance = () => {
    const { element } = this.props;
    if (element.formId !== null) {
      return "FORM";
    } else if (element.pageId !== null) {
      return "PAGE";
    } else {
      return "TEMPLATE";
    }
  };
  getElements = () => {
    switch (this.getInheritance()) {
      case "FORM":
        return this.props.form.formElements;
      case "PAGE":
        return this.props.page.pageElements;
      case "TEMPLATE":
        if (this.props.element.parentName === "HEADER") {
          return this.props.template.template.content.header.content;
        }
        if (this.props.element.parentName === "FOOTER") {
          return this.props.template.template.content.footer.content;
        }
      default:
        return;
    }
  };
  onSelect = (element) => {
    const { dispatch, cms } = this.props;
    if (!cms.editMode) {
      return;
    }
    switch (this.getInheritance()) {
      case "FORM":
        dispatch(formActions.select(element));
        break;
      case "TEMPLATE":
        if (cms.enviroment === sourceTypes.TEMPLATE) {
          dispatch(templateActions.select(element));
        }
        break;
      case "PAGE":
        dispatch(pageActions.select(element));
      default:
        break;
    }
  };
  onDelete = (element) => {
    const { dispatch } = this.props;
    switch (this.getInheritance()) {
      case "FORM":
        dispatch(formActions.remove(element));
        break;
      case "TEMPLATE":
        dispatch(templateActions.remove(element, element.parentName));
        break;
      case "PAGE":
        dispatch(pageActions.remove(element));
      default:
        break;
    }
  };

  handleMouseLeave = () => {
    if (!this.props.cms.editMode) {
      return;
    }
    this.props.disableDropParent(false);
  };
  handleMouseOver = () => {
    if (!this.props.cms.editMode) {
      return;
    }
    this.props.disableDropParent(true);
  };
  getChildren2 = (id, elements) => {
    let children = elements
      .filter((el) => {
        return el.parentId === id;
      })
      .sort((a, b) => {
        let x = a.sortOrder;
        let y = b.sortOrder;
        return y < x ? 1 : y > x ? -1 : 0;
      });
    return children;
  };
  getSelectedElementSource = () => {
    switch (this.getInheritance()) {
      case "FORM":
        return this.props.form.selectedElement;
      case "TEMPLATE":
        return this.props.template.selectedElement;
      case "PAGE":
        return this.props.page.selectedElement;
      default:
        return null;
    }
  };
  render() {
    let selectedElement = this.getSelectedElementSource();
    const { cms, template } = this.props;
    const containers = this.calculateChildren();
    const { element } = this.props;
    const { isDropDisabled } = this.state;

    if (element && element.data && element.data.hidden && !cms.editMode) return null;
    return (
      <div style={{ display: "flex", justifyContent: "center", width: '100%' }}>
        <Row
          style={{
            minHeight: element.parentName !== undefined ? "auto" : "80px",
            height:
              element.parentName === undefined && template.previewDevice === "desktop"
                ? !element.data.style.height || element.data.style.height < 1 || (parseInt(element.data.style.height) === 200 && containers.containerChildrenChildren.length > 1)
                  ? "auto"
                  : element.data.style.height
                : "inherit",
            width: element.data.style.width.toString()?.includes("px") ? element.data.style.width : parseInt(element.data.style.width) + "%",
            maxWidth: element.data.style.width.toString().includes("px") ? element.data.style.width : undefined,
            margin:  element.data.margin,
            padding: /* element.data.padding.toString().includes('px') ? */ element.data.padding /*  : element.data.padding + 'px' */,
            background: element.data.background,
            backgroundAttachment: element.data.backgroundAttachment,
          /*   marginLeft: "auto !important",
            marginRight: "auto !important", */
            paddingTop: element.data.type === "EVENT_GROUP" ? 10 : 0,
          }}
        >
          <Row style={{ marginLeft: "25px", position: "absolute", top: 0 }}>
            <Input style={{ display: "none" }} valid={element.isValid === true} invalid={element.isValid === false} />
            <FormFeedback valid={element.isValid === true}>{element.isValid === false ? element.data.validation.message : null}</FormFeedback>
          </Row>
          {element.data.hidden && (
            <div className="hidden-element">
              <i className="fa fa-eye-slash hidden-element-icon" />
            </div>
          )}
          {element.data.hidden}
          {containers.containerChildren &&
            containers.containerChildren.length > 0 &&
            containers.containerChildren
              .sort((a, b) => {
                let x = a.sortOrder;
                let y = b.sortOrder;
                return y < x ? 1 : y > x ? -1 : 0;
              })
              .map((el, index) => {
                return (
                  <Droppable
                    key={index}
                    droppableId={`column-${el.id}-${el.contentId}${element.parentName !== undefined ? "&" + element.parentName : ""}`}
                    isDropDisabled={isDropDisabled}
                    direction="vertical"
                  >
                    {(provided, snapshot) => (
                      <DropAreaContainer
                        className="container-x responsive-col-wrapper"
                        {...provided.droppableProps}
                        isDraggingOver={snapshot.isDraggingOver}
                        ref={provided.innerRef}
                        key={index}
                        style={{
                          width: cms.editMode && template.previewDevice === "smartphone" ? "100% " : el.data.style.width,
                        }}
                        onMouseEnter={this.handleMouseOver}
                        onMouseOver={this.handleMouseOver}
                        onMouseLeave={this.handleMouseLeave}
                      >
                        {containers.containerChildrenChildren &&
                          containers.containerChildrenChildren.find((cel) => {
                            return cel.id === el.id;
                          }).elements &&
                          containers.containerChildrenChildren
                            .find((cel) => {
                              return cel.id === el.id;
                            })
                            .elements.map((cel, index) => {
                              return (
                                <div className="animated fadeIn" key={index}>
                                  <Draggable draggableId={cel.contentId} index={index}>
                                    {(provided, snapshot) => {
                                      let transform = provided.draggableProps.style.transform;
                                      if (snapshot.isDragging) {
                                        let regex = new RegExp("translate\\((.*?)px, (.*?)px\\)");
                                        let parentValues = regex.exec(this.props.parentTransform || "");
                                        let childValues = regex.exec(provided.draggableProps.style.transform || "");
                                        if (childValues != null && parentValues != null) {
                                          let x = parseFloat(childValues[1], 10) - (parseFloat(parentValues[1], 10) + parseFloat(provided.draggableProps.style.left, 10)) + 20;
                                          let y = parseFloat(childValues[2], 10) - (parseFloat(parentValues[2], 10) + parseFloat(provided.draggableProps.style.top, 10));
                                          transform = `translate(${x}px, ${y}px)`;
                                        }
                                      }
                                      return (
                                        <DragContainer
                                          {...provided.draggableProps}
                                          {...this.props}
                                          ref={provided.innerRef}
                                          isDragging={snapshot.isDragging}
                                          style={{
                                            ...provided.draggableProps.style,
                                            transform,
                                            heigh: 100,
                                          }}
                                        >
                                          <div className="element-container">
                                            <Row
                                              style={{
                                                width: "100%",
                                                display: "flex",
                                                margin: "0px",

                                                border: selectedElement && selectedElement.contentId === cel.contentId ? "2px solid #5593dc94" : "none",
                                              }}
                                              onMouseOver={this.handleMouseOver}
                                              onMouseLeave={this.handleMouseLeave}
                                              onClick={() => this.onSelect(cel)}
                                            >
                                              <Col style={{ padding: "0px" }}>
                                                <Row
                                                  className="lg-12"
                                                  style={
                                                    cel.type === elementConstants.CONTENT && cel.props.type === "IMG" && cel.data.type === "CIRCLE"
                                                      ? {
                                                          margin: "auto",
                                                          width: "100%",
                                                        }
                                                      : {
                                                          margin: "0px",
                                                          width: "100%",
                                                        }
                                                  }
                                                >
                                                  {renderElement(cel.type, cel)}
                                                </Row>
                                                <ElementOverlay targetElement={cel} dragHandleProps={provided.dragHandleProps} selectedElement={selectedElement} onDelete={this.onDelete} />
                                              </Col>
                                            </Row>
                                          </div>
                                        </DragContainer>
                                      );
                                    }}
                                  </Draggable>
                                  {containers.containerChildrenChildren.length > 0 && provided.placeholder}
                                </div>
                              );
                            })}

                        {containers.containerChildrenChildren &&
                        containers.containerChildrenChildren.find((cel) => {
                          return cel.id === el.id;
                        }).elements.length < 1 ? (
                          <div
                            onMouseOver={this.handleMouseOver}
                            onMouseLeave={this.handleMouseLeave}
                            style={{
                              width: "100%",
                              height: !element.data.style.height || element.data.style.height < 1 ? "auto" : element.data.style.height,
                              border: this.props.cms.editMode && "2px dotted #0000000f",
                            }}
                          >
                            {provided.placeholder}
                          </div>
                        ) : (
                          <div /* style={{ height: '200px' }} */>{provided.placeholder}</div>
                        )}
                      </DropAreaContainer>
                    )}
                  </Droppable>
                );
              })}
        </Row>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    form: state.form,
    template: state.template,
    cElements: state.elements,
    cms: state.cms,
    page: state.page,
  };
}

export default connect(mapStateToProps)(Container);
